export type SelectedElement = {
  id: string;
};

export enum TextureVariant {
  Floor = 'floor',
  Highway = 'tire_stain',
  Debug = 'debug_texture',
  Brick = 'brick_wall',
  Concrete = 'concrete',
  Stone = 'stone',
  WarningZone = 'warning_zone',
  ScanField = 'scanfield',
  BrickFloor = 'brick_floor',
  Fence = 'fence',
}
